<script>
export default {
    name: 'heading',

    props: 
    {
        level: {
            type: Number,
            default: 1,
        },
        center: Boolean,
    },

    render(h) 
    {
        return h(
            'h' + this.level, 
            {
                class: 
                {
                    'text-center': this.center, 
                },
            }, this.$slots.default
        )
    },
}
</script>
<style lang="scss">
    @import "../../assets/styles/settings/settings";

    h1, h2, h3, h4, h5, h6 {
        font-weight: bold;
    }

    h1 {
        line-height: rem(58);
        letter-spacing: rem(-0.05);
    }

    h2 {
        line-height: rem(40);
        letter-spacing: rem(-0.05);
        margin-top: rem(40);
    }

    h3 {
        line-height: rem(30);
        letter-spacing: rem(-0.05);
        margin-top: rem(30);
    }

    h4 {
        line-height: rem(28);
        margin-top: rem(28);

        &.spaced {
            letter-spacing: 1px;
            font-weight: 600;
            text-transform: uppercase;
        }
    }

    h5 {
        line-height: rem(22);
        letter-spacing: rem(0.1);
        margin-top: rem(22);
    }

    h6 {
        line-height: rem(18);
        letter-spacing: rem(0.25);
        margin-top: rem(18);
        text-transform: uppercase;
    }
</style>
